<template>
    <div class="secondary-filters pt-1">
        <div class="form-group border-0 m-0 p-0 ">
            <div class="form-row w-100">
                <div v-if="!$root.is_mobile && config.filters.rooms" class="col-md-6  pr-2">
                    <h5>{{ lang.labels.rooms | capitalize }}</h5>
                    <div class="border-bottom-0 form-group">
                        <div class="form-row">
                            <div class="col-6">
                                <my-input
                                    type="text"
                                    v-model="filters.min_rooms"
                                    name="min_rooms"
                                    :label="lang.labels.min_rooms | capitalize"
                                    @blur="filtersUpdated"
                                />
                            </div>

                            <div class="col-6">
                                <my-input
                                    type="text"
                                    v-model="filters.max_rooms"
                                    name="max_rooms"
                                    :label="lang.labels.max_rooms | capitalize"
                                    @blur="filtersUpdated"
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <!-- <div
                    v-if="config.filters.subsubtype"
                    class="col-md-6 subsubtype pr-2"
                >
                    <h5>{{ lang.labels.subsubtype | capitalize }}</h5>

                    <filter-select
                        ref="subsubtype"
                        name="subsubtype"
                        clearable
                        v-model="filters.subsubtype"
                        :items="filterSubsubtype"
                        :label="lang.labels.any | capitalize"
                        @updated="filtersUpdated"
                    />
                </div> -->

                <div class="col-lg-6">
                    <bathrooms-filter
                        v-if="config.filters.bathrooms"
                        ref="bathrooms"
                        v-model="filters.bathrooms"
                        :label="lang.labels.bathrooms | capitalize"
                        @updated="filtersUpdated"
                    />
                </div>
            </div>
        </div>

        <div class="form-group  border-0">
            <div class="form-row">
                <div
                    v-if="config.filters.status"
                    class="col-md-6 status pr-2"
                >
                    <h5>{{ lang.labels.status | capitalize }}</h5>

                    <filter-select
                        ref="status"
                        name="status"
                        clearable
                        v-model="filters.status"
                        :items="filterValues.statuses"
                        :label="lang.labels.any | capitalize"
                        @updated="filtersUpdated"
                    />
                </div>

                <div
                    v-if="config.filters.status_tecnocasa"
                    class="col-md-6 status pr-2"
                >
                    <h5>{{ lang.labels.status | capitalize }}</h5>

                    <filter-select
                        ref="status_tecnocasa"
                        name="status_tecnocasa"
                        clearable
                        v-model="filters.status_tecnocasa"
                        :items="filterValues.statuses"
                        :label="lang.labels.any | capitalize"
                        @updated="filtersUpdated"
                    />
                </div>

                <div
                    v-if="config.filters.property_type"
                    class="col-md-6"
                >
                    <h5>{{ lang.labels.property_type | capitalize }}</h5>

                    <filter-select
                        ref="property_type"
                        name="property_type"
                        clearable
                        v-model="filters.property_type"
                        :items="filterValues.property_types"
                        :label="lang.labels.any | capitalize"
                        @updated="filtersUpdated"
                    />
                </div>
            </div>
        </div>

        <div
            v-if="config.filters.subsubtype && filterSubsubtype.length"
            class="form-group mb-1 filter-border"
        >
            <div class="form-row">
                <div class="col-md-12">
                    <filter-checkbox
                        ref="subsubtype"
                        name="subsubtype"
                        v-model="filters.subsubtype"
                        :items="filterSubsubtype"
                        :label="lang.labels.subsubtype"
                        :multiple="true"
                        @updated="filtersUpdated"
                    />
                </div>
            </div>
        </div>

        <div
            v-if="config.filters.garage"
            class="form-group mb-1 filter-border"
        >
            <div class="form-row">
                <div class="col-md-12">
                    <filter-checkbox
                        ref="garage"
                        name="garage"
                        v-model="filters.garage"
                        :items="filterValues.garages"
                        :label="lang.labels.garage"
                        :multiple="true"
                        @updated="filtersUpdated"
                    />
                </div>
            </div>
        </div>

        <div
            v-if="config.filters.heating"
            class="form-group mb-1 filter-border"
        >
            <div class="form-row">
                <div class="col-md-12">
                    <filter-checkbox
                        ref="heating"
                        name="heating"
                        v-model="filters.heating"
                        :items="filterValues.heatings"
                        :label="lang.labels.heating"
                        :multiple="true"
                        @updated="filtersUpdated"
                    />
                </div>
            </div>
        </div>

        <div
            v-if="config.filters.air_conditioning"
            class="form-group mb-1 filter-border"
        >
            <div class="form-row">
                <div class="col-md-12">
                    <filter-checkbox
                        ref="air_conditioning"
                        name="air_conditioning"
                        v-model="filters.air_conditioning"
                        :items="filterValues.air_conditioning"
                        :label="lang.labels.air_conditioning"
                        :multiple="true"
                        @updated="filtersUpdated"
                    />
                </div>
            </div>
        </div>

        <div
            v-if="config.filters.balcony"
            class="form-group mb-1 filter-border"
        >
            <div class="form-row">
                <div class="col-md-12">
                    <filter-checkbox
                        ref="balcony"
                        name="balcony"
                        v-model="filters.balcony"
                        :items="filterValues.balconies"
                        :label="lang.labels.balcony"
                        :multiple="true"
                        @updated="filtersUpdated"
                    />
                </div>
            </div>
        </div>

        <div
            v-if="config.filters.garden"
            class="form-group mb-1 filter-border"
        >
            <div class="form-row">
                <div class="col-md-12">
                    <filter-checkbox
                        ref="garden"
                        name="garden"
                        v-model="filters.garden"
                        :items="filterValues.gardens"
                        :label="lang.labels.garden"
                        :multiple="true"
                        @updated="filtersUpdated"
                    />
                </div>
            </div>
        </div>

        <div
            v-if="config.filters.energy_class"
            class="form-group mb-1 filter-border"
        >
            <div class="form-row">
                <div class="col-md-12">
                    <filter-checkbox
                        ref="energy_class"
                        name="min_ce"
                        v-model="filters.min_ce"
                        :items="filterValues.energy_classes"
                        :label="lang.labels.ce"
                        :multiple="true"
                        @updated="filtersUpdated"
                    />
                </div>
            </div>
        </div>

        <div
            v-if="config.filters.furnitured"
            class="form-group mb-1 filter-border"
        >
            <div class="form-row">
                <div class="col-md-12">
                    <filter-checkbox
                        ref="furnitured"
                        name="furnitured"
                        v-model="filters.furnitured"
                        :items="filterValues.furnitured"
                        :label="lang.labels.furnitured"
                        :multiple="true"
                        @updated="filtersUpdated"
                    />
                </div>
            </div>
        </div>

        <div
            v-if="config.filters.other"
            class="form-group pb-5"
        >
            <div class="form-row">
                <div class="col-md-12">
                    <h5>{{ lang.labels.other_filters | capitalize }}</h5>

                    <template v-for="other_filter in filterValues.other_filters">
                        <filter-checkbox
                            ref="other_filter"
                            :name="other_filter.id"
                            v-model="filters[other_filter.id]"
                            :item="other_filter"
                            :multiple="false"
                            @updated="filtersUpdated"
                        />
                    </template>

                    <!-- <filter-checkbox
                        v-if="config.filters.other.concierge"
                        ref="concierge"
                        name="concierge"
                        v-model="filters.concierge"
                        :item="filterValues.other_filters[0]"
                        :multiple="false"
                        @updated="filtersUpdated"
                    />

                    <filter-checkbox
                        v-if="config.filters.other.lift"
                        ref="lift"
                        name="lift"
                        v-model="filters.lift"
                        :item="filterValues.other_filters[1]"
                        :multiple="false"
                        @updated="filtersUpdated"
                    />

                    <filter-checkbox
                        v-if="config.filters.other.virtual_tour"
                        ref="virtual_tour"
                        name="virtual_tour"
                        v-model="filters.virtual_tour"
                        :item="filterValues.other_filters[2]"
                        :multiple="false"
                        @updated="filtersUpdated"
                    /> -->
                </div>
            </div>
        </div>

        <div v-if="!$root.is_mobile" class="form-group">
            <div class="search-button mt-1 pt-1">
                <div>
                    <button class="btn btn-network btn-sm undo mr-1" @click="filtersReset">
                        {{ lang.labels.reset }}
                    </button>
                    <button class="btn btn-network btn-sm btn-apply float-right" @click="modalClose">
                        {{ applyTitle }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Bathrooms from './Bathrooms'
import FilterCheckbox from './Checkbox'
import FilterSelect from './Select'
import MyRangeInput from './MyRangeInput'

export default {
    components: {
        'bathrooms-filter': Bathrooms,
        'filter-checkbox': FilterCheckbox,
        'filter-select': FilterSelect,
        'my-range-input': MyRangeInput,
    },

    props: {
        config: {
            type: Object,
            required: true,
        },

        count: {
            type: Number,
            required: false,
        },

        fallback: {
            type: Boolean,
            required: false,
        },

        filters: {
            type: Object,
            required: true,
        },

        filterValues: {
            type: Object,
            required: true,
        },

        lang: {
            type: Object,
            required: true,
        },
    },

    // mounted() {
    //     window.events.$on('reset-subsubtype', event => {
    //         this.filters.subsubtype = null
    //     })
    // },

    methods: {
        filtersUpdated(event) {
            this.$emit('updated', event)
        },

        modalClose() {
            this.$emit('close')
        },

        filtersReset() {
            this.$refs.other_filter.forEach(filter => {
                filter.clearInput()
            })

            for (const [filter_key, filter] of Object.entries(this.config.filters)) {
                if (filter == 1 && filter_key != 'other' && filter_key != 'rooms') {
                    this.$refs[filter_key].clearInput()
                    this.filters[filter_key] = null
                }
            }

            this.filters.min_rooms = null
            this.filters.max_rooms = null

            this.filtersUpdated()
            this.$emit('close')
        },

        toggleCheckbox(field) {
            this.filters[field] = this.filters[field] ? 1 : null

            this.$forceUpdate()

            this.filtersUpdated()
        }
    },

    computed: {
        applyTitle() {
            var count = ((this.fallback == false) && (this.count > 0)) ? this.count : ''
            return this.lang.labels.apply.replace(':count', count)
        },

        filterSubsubtype() {
            if (this.config.filters.subsubtype) {
                if (!this.filters.type) {
                    return this.filterValues.subsubtypes
                } else if (this.filterValues['subsubtypes_' + this.filters.type]) {
                    return this.filterValues['subsubtypes_' + this.filters.type]
                } else {
                    return []
                }
            }
        }
    },
}
</script>